import React from 'react';
import * as styles from './styles.module.scss';
import TrailUgcTab from '../types/TrailUgcTab';
import ReviewsGraph from './ReviewsGraph';
import RatingsBreakdown from '../types/RatingsBreakdown';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

type TrailUgcBarInvitationProps = {
  activeTab: TrailUgcTab;
  itemCount: number;
  ratingsBreakdown?: RatingsBreakdown;
  showInvitation: boolean;
};

const TrailUgcBarInvitation = ({ activeTab, itemCount, ratingsBreakdown, showInvitation }: TrailUgcBarInvitationProps): JSX.Element => {
  if (!showInvitation) {
    return null;
  }

  let templateString: string;
  let paragraphText: string;
  switch (activeTab) {
    case 'reviews':
      if (!ratingsBreakdown) {
        return null;
      }
      return <ReviewsGraph itemCount={itemCount} ratingsBreakdown={ratingsBreakdown} />;
    case 'photos':
      return (
        <div className={styles.invitationContainer}>
          <h5 className={styles.invitationHeader}>{StringConstantsMixin.strings.ADD_YOUR_PHOTOS}</h5>
          <p className={styles.invitationText}>{StringConstantsMixin.strings.PHOTOS_HELP_OTHERS}</p>
        </div>
      );
    case 'tracks':
      return (
        <div className={styles.invitationContainer}>
          <h5 className={styles.invitationHeader}>{StringConstantsMixin.strings.SHARE_YOUR_ROUTE}</h5>
          <p className={styles.invitationText}>{StringConstantsMixin.strings.RECORDINGS_HELP_OTHERS}</p>
        </div>
      );
    case 'completed':
      templateString =
        // eslint-disable-next-line no-nested-ternary
        itemCount === 0
          ? StringConstantsMixin.strings.USE_RECORDER_ZERO
          : itemCount === 1
          ? StringConstantsMixin.strings.USE_RECORDER_SINGULAR
          : StringConstantsMixin.strings.USE_RECORDER_PLURAL;
      paragraphText = templateString.replace('{completedCount}', itemCount.toString());
      return (
        <div className={styles.invitationContainer}>
          <h5 className={styles.invitationHeader}>{StringConstantsMixin.strings.JOIN_THE_LIST}</h5>
          <p className={styles.invitationText}>{paragraphText}</p>
        </div>
      );
    default:
      return null;
  }
};

export default TrailUgcBarInvitation;
